import React from 'react';
import { Navigate } from 'react-router-dom';
import { roles } from '@nxsys/store/constants';

// NX-4996. Change password and two-factor are two sections of one screen rather
// than two pages — Victor asked for one nav holding everything about account
// security, Thang for one screen with tabs.
const AccountSecurity = React.lazy(
  () => import('../../../modules/account/AccountSecurity'),
);

const accountSecurityRoles = [
  roles.supper_admin,
  roles.admin,
  roles.employer,
  roles.employee,
  roles.agency,
];

const PASSWORD = '/account-security/password';
const TWO_FACTOR = '/account-security/two-factor';

export const changePasswordConfig = [
  {
    permittedRole: accountSecurityRoles,
    path: PASSWORD,
    element: <AccountSecurity />,
  },
  {
    permittedRole: accountSecurityRoles,
    path: TWO_FACTOR,
    element: <AccountSecurity />,
  },
  {
    permittedRole: accountSecurityRoles,
    path: '/account-security',
    element: <Navigate to={PASSWORD} replace />,
  },
  // The old paths keep working: `/change-password` has been a real URL for a
  // while and support hands `/two-factor` out, so neither can just 404.
  {
    permittedRole: accountSecurityRoles,
    path: '/change-password',
    element: <Navigate to={PASSWORD} replace />,
  },
  {
    permittedRole: accountSecurityRoles,
    path: '/two-factor',
    element: <Navigate to={TWO_FACTOR} replace />,
  },
];
